import { useLocation } from "react-router-dom";

export const useWhatsAppMessage = () => {
  const location = useLocation();

  const getMessageByRoute = () => {
    const currentHour = new Date().getHours();
    const greeting =
      currentHour < 12
        ? "Buenos días"
        : currentHour < 18
        ? "Buenas tardes"
        : "Buenas noches";

    switch (true) {
      case location.pathname === "/":
        return `${greeting}! Me interesa conocer más sobre sus vehículos usados. ¿Podrían ayudarme?`;

      case location.pathname === "/catalogo":
        return `${greeting}! Estoy viendo su catálogo de vehículos y me gustaría recibir más información.`;

      case location.pathname.startsWith("/producto/"): {
        const productSlug = location.pathname.split("/producto/")[1];
        return `${greeting}! Me interesa el vehículo "${productSlug
          .replace(/-/g, " ")
          .toUpperCase()}" que estoy viendo. ¿Podrían darme más detalles? \n${
          window.location.href
        }`;
      }

      case location.pathname === "/admin":
        return `${greeting}! Tengo una consulta administrativa.`;

      default:
        return `${greeting}! ¿Podrían ayudarme con información sobre sus servicios?`;
    }
  };

  return getMessageByRoute();
};
